import { shallowEqual } from 'react-redux';
import { PapiGallection } from '@wix/da-papi-types';
import { connectMediaStore, useMMSelector } from './withOwnReduxStore';
import { getCurrentGallectionSubfolders, getCurrentSubfolderId } from '../selectors';

export type WithCurrentGallectionSubfoldersProps = {
  subfolders: PapiGallection[];
  currentSubfolderId?: number;
};

const mapStateToProps = state => ({
  subfolders: getCurrentGallectionSubfolders(state),
  currentSubfolderId: getCurrentSubfolderId(state),
});

export const useCurrentGallectionSubfolders = (): WithCurrentGallectionSubfoldersProps => ({
  ...useMMSelector(mapStateToProps, shallowEqual),
});

export default connectMediaStore(mapStateToProps);
